import { useMemo } from 'react';
import { toNumber } from 'products-ui-components/utils/toNumber';
import { ProductIdContext } from '../contexts/ProductIdContext';
import { ProductLoadingContext } from '../contexts/ProductLoadingContext';
import { ProductDataContext } from '../contexts/ProductDataContext';
import { ProductPropertiesContext } from '../contexts/ProductPropertiesContext';
import { ProductCurrencyContext } from '../contexts/ProductCurrencyContext';
import { useProductDependencies } from '../hooks/useProductDependencies';
import { ProductErrorContext } from '../contexts/ProductErrorContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductDependenciesProvider = ({
  objectId,
  children
}) => {
  const numberObjectId = toNumber(objectId);
  const {
    loading,
    errors,
    productData,
    productProperties,
    defaultCurrencyCode,
    isMulticurrencyActive,
    currencyProperties
  } = useProductDependencies(numberObjectId);
  const currencyContextValue = useMemo(() => ({
    defaultCurrencyCode,
    isMulticurrencyActive,
    currencyProperties
  }), [defaultCurrencyCode, isMulticurrencyActive, currencyProperties]);
  return /*#__PURE__*/_jsx(ProductIdContext.Provider, {
    value: numberObjectId,
    children: /*#__PURE__*/_jsx(ProductLoadingContext.Provider, {
      value: loading,
      children: /*#__PURE__*/_jsx(ProductErrorContext.Provider, {
        value: errors,
        children: /*#__PURE__*/_jsx(ProductDataContext.Provider, {
          value: productData,
          children: /*#__PURE__*/_jsx(ProductPropertiesContext.Provider, {
            value: productProperties,
            children: /*#__PURE__*/_jsx(ProductCurrencyContext.Provider, {
              value: currencyContextValue,
              children: children
            })
          })
        })
      })
    })
  });
};